/*
 * Catalog page
 * - replaces AppSummary as the entry point to the (App)Catalog
 * - the notion of catalog is expanded.  This experience contains 3 tabs:
 *   - Apps (the app catalog - apps sold by the reseller)
 *   - Services (new experience - services sold by the reseller)
 *   - Vendor programs (new experience - reseller programs that the reseller is registered for)
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Tab, Tabs } from '@mui/material';

import { Apps, Work, AttachMoney, MailOutline } from '@mui/icons-material';
import CatalogApps from './CatalogApps';
import CatalogServices from './CatalogServices';
import Invitations from './Invitations';
/*import CatalogCommissions from './CatalogCommissions';*/
import PartnerProgramsContainer from '../vendor/PartnerProgramsContainer';

import PageTitle from '../ui/PageTitle';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  tabroot: {
    flexGrow: 1,
    margin: 0,
    width: '100%',
    //backgroundColor: theme.palette.primary.light,
    borderBottom: '2px solid #dedede'
  },
  flex: {
    flex: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    maxWidth: 1200,
    marginTop: 16,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  tabScrollButton:{
    flex: '0 0 0px'
  },

  /* Hidden below is sort of a hack.  Without overflow hidden - scroll bars appear but were not revealing 
  more data.  It was not obvious what is causing it.  Needs more research */

  /* Screen size specific styles */
  [theme.breakpoints.up('xs')]: {
    tabContainer: {
      padding: 0,
      overflow: 'hidden'
    },

    /* Tab navigation */
    tab: {
      fontSize: 'xx-small',
    },
    labelContainer: {
      paddingLeft: 4,
      paddingRight: 4,
    },
    label: {
      fontSize: 'xx-small',
    },
    labelWrapped: {
      fontSize: 'xx-small',
    },
  }
  ,
  [theme.breakpoints.up('sm')]: {
    tabContainer: {
      padding: 8,
      overflow: 'hidden'
    },

    /* Tab navigation */
    tab: {
      fontSize: 'x-small',
    },
    labelContainer: {
      paddingLeft: 8,
      paddingRight: 8,
    },
    label: {
      fontSize: 'x-small',
    },
    labelWrapped: {
      fontSize: 'x-small',
    },
  },
  [theme.breakpoints.up('md')]: {
    tabContainer: {
      padding: 20,
      overflow: 'hidden'
    },
  
    /* Tab navigation */
    tab: {
      fontSize: '0.75rem',
    },
    labelContainer: {
      paddingLeft: 12,
      paddingRight: 12,
    },
    label: {
      fontSize: '0.75rem',
    },
    labelWrapped: {
      fontSize: '0.75rem',
    },
  }
});

function TabContainer(props) {
  const classes = props.classes;
  return <div className={classes.tabContainer}>{props.children}</div>;
}

class Catalog extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: 0
    }
  }

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) { window.analytics.page(); }

    // Is there something in local storage?
    let theValue = 0;
    let tabval = localStorage.getItem('catalogTabVal');
    if (tabval !== null) {
      theValue = parseInt(tabval, 10);
    }

    this.setState({value: theValue});
  }

  handleTabChange = (event, value) => {
    this.setState({ value });
    localStorage.setItem('catalogTabVal', value);
  }

  setTabValue = (tv) => {
    this.setState({value: tv});
    localStorage.setItem('catalogTabVal', tv);
  }

  goTo(route) {
     this.props.history.push(`/${route}`);
  }
 
  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent } = this.props.auth;
    const classes = this.props.classes;
    const { value } = this.state;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller() ) {

      // Check feature flags
      let serviceBillingActive = false;
      let serviceBilling = abEnvironment.getFlagValue("serviceBilling");
      if (serviceBilling != null && serviceBilling.flagValue === 1) {
        serviceBillingActive = true;
      }
      let partnerProgramsActive = false;
      let partnerPrograms = abEnvironment.getFlagValue("partnerPrograms");
      if (partnerPrograms != null && partnerPrograms.flagValue === 1) {
        partnerProgramsActive = true;
      }

      if (serviceBillingActive === false && partnerProgramsActive === false) {
        return (
          <React.Fragment>
            <PageTitle title="Catalog" subtitle="Apps you manage for your customers."/>
            <CatalogApps
              showTitle={false}
              auth={this.props.auth}
              history={this.props.history}
            />
          </React.Fragment>
        );
      }

      let appsTab = 0;
      let servicesTab = 1;
      let partnerProgramsTab = 2;

      if (serviceBillingActive === false) {
        servicesTab = null;
        partnerProgramsTab = 1;
      } else if (partnerProgramsActive === false) {
        partnerProgramsTab = null;
      }

      return (
        <React.Fragment>
          <PageTitle title="Catalog" subtitle="Apps and services you manage for your customers."/>

          <Paper className={classes.paper}>
            <Grid container spacing={0} direction="row" justifyContent="space-around">
              <Grid item xs={12}>
                <Tabs
                  value={value}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  scrollButtons="auto"
                  classes={{root: classes.tabroot, scrollButtons: classes.tabScrollButton}}
                >
                  <Tab label="Apps" icon={<Apps />}
                    classes={{
                        root: classes.tab,
                        wrapper: classes.labelWrapped,
                      }}
                  />
                  { servicesTab != null &&
                  <Tab label="Services" icon={<Work />}
                    classes={{
                      root: classes.tab,
                      wrapper: classes.labelWrapped,
                    }}
                  />}
                  { partnerProgramsTab != null &&
                  <Tab label="Partner programs" icon={<AttachMoney />}
                    classes={{
                      root: classes.tab,
                      wrapper: classes.labelWrapped,
                    }}
                  />}
              </Tabs>
              </Grid>
              <Grid item xs={12} style={{marginTop: '10px'}}>
                {value === appsTab &&
                <TabContainer {...this.props}>
                  <CatalogApps 
                    showTitle={true}
                    auth={this.props.auth}
                    history={this.props.history}
                  />
                </TabContainer>}
                {value === servicesTab &&
                <TabContainer {...this.props}>
                  <CatalogServices 
                      auth={this.props.auth}
                      history={this.props.history}
                  />
                </TabContainer>}
                {value === partnerProgramsTab &&
                <TabContainer {...this.props}>
                  <PartnerProgramsContainer
                    auth={this.props.auth}
                    history={this.props.history}
                  />                      
                </TabContainer>}
              </Grid>
            </Grid>
          </Paper>
        </React.Fragment>
      );
    }
  }
}

Catalog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Catalog);
